import { inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { UserInfo, UserInfoService } from '@mobi/rwc-utils-azure-ng-jslib';

import { AuthenticationService, UserData } from '../authentication.service';

export class CipUserInfoService extends UserInfoService {
    readonly loggedInUser: Observable<UserInfo> = inject(AuthenticationService).getUserData().pipe(map(toUserInfo));
}

const toUserInfo = (user: UserData): UserInfo => ({
    userId: user.preferred_username,
    email: user.email,
    fullname: user.name
});
